module.exports = "/assets/40fddec264e7fe491029483345ca8684.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/D2.png
// module id = 1286
// module chunks = 0